import React, { SVGProps } from "react";

export default function ArrowBack(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        opacity="0.4"
        d="M7.81 2.5683H16.18C19.83 2.5683 22 4.7383 22 8.3783V16.7483C22 20.3883 19.83 22.5583 16.19 22.5583H7.81C4.17 22.5683 2 20.3983 2 16.7583V8.3783C2 4.7383 4.17 2.5683 7.81 2.5683Z"
        fill="currentColor"
      />
      <path
        d="M5.47 12.0383L9.76 7.74829C10.05 7.45829 10.53 7.45829 10.82 7.74829C11.11 8.03829 11.11 8.51829 10.82 8.80829L7.81 11.8183H18C18.41 11.8183 18.75 12.1583 18.75 12.5683C18.75 12.9783 18.41 13.3183 18 13.3183H7.81L10.82 16.3283C11.11 16.6183 11.11 17.0983 10.82 17.3883C10.67 17.5383 10.48 17.6083 10.29 17.6083C10.1 17.6083 9.91 17.5383 9.76 17.3883L5.47 13.0983C5.32955 12.9577 5.25066 12.767 5.25066 12.5683C5.25066 12.3695 5.32955 12.1789 5.47 12.0383Z"
        fill="currentColor"
      />
    </svg>
  );
}
